export default __webpack_public_path__ + "static/media/SurvivalRent.50cd9397.pdf";